
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      type: 'hours',
    };
  },
  methods: {
    switchType(type: string) {
      this.type = type;
      this.$emit('data-type', type);
    },
  },
});
